// `/inbox` — the Agent Inbox, redesigned as the two-pane triage view
// (Smokeball design system, design 1e).
//
// The page is a thin route shell: all queue/detail composition lives in
// the colocated `<InboxTriage>` (triage.tsx), which reuses the SAME BFF
// queries the previous `@sb-ai-platform/ui-react` `<AgentInbox>` consumed
// through the platform adapter (approvals.list / runs.list / agents.list
// / approvals.decide). No new backend surface.
//
// **Routing contract (unchanged from app.tsx):** `/inbox` renders the
// queue with nothing selected; picking a queue item navigates to
// `/inbox/:id` (see detail.tsx) so selection survives refresh and deep
// links keep working.

import { InboxTriage } from './triage.js';

export function InboxPage(): React.ReactElement {
  return <InboxTriage />;
}
